export default {
    loading: 'user:group:loading', // 流加载
    search: 'user:group:search',
    userGroups: 'user:group:userGroups',
    userGroup: 'user:group:userGroup',
    users: 'user:group:users',
    modal: 'user:group:modal',
}

// users 对象的转换 string[] -> object[] 
export const encode = (usergroup) => {
    let users = usergroup.users;
    if (users) {
        users = users.map((v, i) => {
            return { '_id': v.split(",")[0], 'name': v.split(",")[1] };
        });
    }
    return Object.assign({}, usergroup, { users: users })
}

// users 对象的转换 object[]  ->  string[]
export function decode(usergroup) {
    let users = usergroup.users;
    if (users) {
        users = users.map((user, k) => {
            return user._id + ',' + user.name;
        })
    }
    return Object.assign({}, usergroup, { users: users })
}



// WEBPACK FOOTER //
// ./pages/user/userGroup/constant.js